import { css } from '@eti/styles';
import { Card, Inline, Text, textVariants, type TextVariantsType } from '@etg/wings';
import type { ReactNode } from 'react';
import { ScreenReaderPrice } from '@eti/components';

const inlineStyles = css`
  justify-content: space-between;
`;

interface PaymentItemProps {
  accessiblePrice?: string;
  children?: ReactNode;
  className?: string;
  textVariant?: TextVariantsType;
  dataTestId?: string;
  price: string;
  title: string;
}

const PaymentItem = ({
  accessiblePrice,
  children,
  className,
  dataTestId,
  price,
  textVariant = textVariants._14,
  title,
}: PaymentItemProps) => {
  return (
    <Card.Section className={className} data-testid={dataTestId}>
      <Inline className={inlineStyles}>
        <Text variant={textVariant}>{title}</Text>
        <Text aria-hidden data-testid={`${dataTestId}-visible`} variant={textVariant}>
          {price}
        </Text>
        <ScreenReaderPrice price={accessiblePrice ?? price} />
      </Inline>
      {children}
    </Card.Section>
  );
};

export default PaymentItem;
